var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item",
      class: { item2: _vm.type == 5 || _vm.type == 6 },
      on: {
        click: function ($event) {
          return _vm.lookDetails(_vm.item.courseLink)
        },
      },
    },
    [
      _vm.type == 5
        ? _c("div", { staticClass: "img2" }, [
            _c("img", {
              attrs: {
                src: _vm.item.courseImage
                  ? _vm.item.courseImage
                  : _vm.$store.getters.noImg,
              },
            }),
            _vm._v(" "),
            _vm.item.courseLevel !== ""
              ? _c(
                  "div",
                  {
                    staticClass: "leb1",
                    class: {
                      leb1: _vm.item.courseLevel == "国家级",
                      leb1sj: _vm.item.courseLevel == "省级",
                      leb1xh: _vm.item.courseLevel == "校级",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.item.courseLevel))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.item.province
              ? _c("div", { staticClass: "prov" }, [
                  _vm._v(_vm._s(_vm.item.province)),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mainText" }, [
        _vm.type != 9
          ? _c("div", { staticClass: "tit" }, [
              _vm._v(_vm._s(_vm.item.courseName)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 5
          ? _c("div", [
              _c("div", { staticClass: "sourse" }, [
                _c(
                  "div",
                  {
                    staticClass: "text_w",
                    staticStyle: { "margin-bottom": "5px" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.item.fkCourseEmceeSchool
                          ? _vm.item.fkCourseEmceeSchool
                          : "---"
                      )
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-teacher.png") },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.item.courseEmceeName
                          ? _vm.item.courseEmceeName
                          : "---"
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text_w" }, [
                _vm._v(_vm._s(_vm.item.industry ? _vm.item.industry : "---")),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text_w" }, [
                _vm._v(
                  _vm._s(
                    _vm.item.fkCourseMajor ? _vm.item.fkCourseMajor : "---"
                  )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line2" }),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [
                _c("div", { staticClass: "name" }, [
                  _c("img", {
                    attrs: { src: require("../assets/img/icon-origin.png") },
                  }),
                  _vm._v(
                    "\n         " +
                      _vm._s(
                        _vm.item.courseFrom ? _vm.item.courseFrom : "---"
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }